var _rect, _path, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialAppleRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.651 16.4c-.08.047-2.005 1.043-2.005 3.25.09 2.516 2.429 3.398 2.469 3.398-.04.048-.353 1.203-1.28 2.414-.736 1.043-1.552 2.094-2.791 2.094-1.18 0-1.603-.695-2.963-.695-1.462 0-1.875.695-2.994.695-1.24 0-2.116-1.108-2.892-2.141-1.007-1.352-1.864-3.474-1.894-5.512-.02-1.08.202-2.141.766-3.043.796-1.259 2.217-2.113 3.769-2.141 1.189-.038 2.247.76 2.972.76.696 0 1.996-.76 3.467-.76.635 0 2.328.179 3.376 1.681zm-6.943-1.897c-.212-.986.373-1.972.917-2.601.695-.76 1.793-1.277 2.74-1.277a3.529 3.529 0 01-1.007 2.658c-.615.76-1.673 1.333-2.65 1.22z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.05,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}

export default SvgSocialAppleRound;